/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes Safari >= 10, Chrome >= 55 (including Opera),
 * Edge >= 13 on the desktop, and iOS 10 and Chrome on mobile.
 *
 * Learn more in https://angular.io/docs/ts/latest/guide/browser-support.html
 */

/***************************************************************************************************
 * BROWSER POLYFILLS
 *
 * NOTE: Most of these polyfills are for IE11 and older browsers.
 * Since browserslist excludes IE11 (commented out), many of these can be removed.
 * However, some may still be needed for older versions of modern browsers.
 * 
 * If you're certain you don't need IE11 support, you can remove most core-js imports.
 * Modern browsers (Chrome, Firefox, Safari, Edge) have native support for these features.
 */

/** 
 * These polyfills are for IE11 and older browsers.
 * Modern browsers (Chrome 55+, Firefox 52+, Safari 10+, Edge 13+) have native support.
 * 
 * OPTIMIZATION: If you don't need IE11 support, you can remove these imports.
 * They add ~200-300KB to your bundle size.
 */
// IE11 polyfills - can be removed if not supporting IE11
// import 'core-js/es/symbol';
// import 'core-js/es/object';
// import 'core-js/es/function';
// import 'core-js/es/parse-int';
// import 'core-js/es/parse-float';
// import 'core-js/es/number';
// import 'core-js/es/math';
// import 'core-js/es/string';
// import 'core-js/es/date';
// import 'core-js/es/array';
// import 'core-js/es/regexp';
// import 'core-js/es/map';
// import 'core-js/es/weak-map';
// import 'core-js/es/set';
// import 'url-polyfill';
// import 'core-js/es/reflect';

/** 
 * url-polyfill: Only needed for IE11 and very old browsers.
 * Modern browsers have native URL API support.
 */
// import 'url-polyfill'; // Remove if not supporting IE11
/** Evergreen browsers require these. **/
// Used for reflect-metadata in JIT. If you use AOT (and only Angular decorators), you can remove.
/**
 * Web Animations `@angular/platform-browser/animations`
 * Only required if AnimationBuilder is used within the application and using IE/Edge or Safari.
 * Standard animation support in Angular DOES NOT require any polyfills (as of Angular 6.0).
 **/
// import 'web-animations-js';  // Run `npm install --save web-animations-js`.
/**
 * By default, zone.js will patch all possible macroTask and DomEvents
 * user can disable parts of macroTask/DomEvents patch by setting following flags
 */
// (window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
// (window as any).__Zone_disable_on_property = true; // disable patch onProperty such as onclick
// (window as any).__zone_symbol__BLACK_LISTED_EVENTS = ['scroll', 'mousemove']; // disable patch specified eventNames
/*
 * in IE/Edge developer tools, the addEventListener will also be wrapped by zone.js
 * with the following flag, it will bypass `zone.js` patch for IE/Edge
 */
// (window as any).__Zone_enable_cross_context_check = true;
/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import 'zone.js'; // Included with Angular CLI.
/******************************************************************
 * Load `$localize` - used if i18n tags appear in Angular templates.
 */
import '@angular/localize/init';
import 'intersection-observer';

/***************************************************************************************************
 * APPLICATION IMPORTS
 */

/** IE11 is the worst */
if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype['msMatchesSelector'];
}
(window as any).global = window;
